<template>
    <v-container>
        <DockDialog
            :dock-data="currentDock"
            :dock-types="dockTypes"
            :is-open="dockDialog"
            @on-confirm="confirmSaveDock"
            @on-close="closeDockDialog"
        />

        <v-row>
            <v-col cols="12">
                <v-card flat>
                    <v-card-title class="pt-0">
                        <v-row align="center">
                            <v-col cols="12" sm="6" md="4">
                                <v-btn
                                    v-if="canCreateDock"
                                    color="secondary"
                                    medium
                                    data-sentry-label="Dodaj dok"
                                    @click="createDock()"
                                >
                                    <v-icon left>
                                        mdi-plus
                                    </v-icon>
                                    Dodaj dok
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card-title>
                    <v-card-text>
                        <v-data-table
                            :headers="headers"
                            :items="docks"
                            :loading="docksLoading"
                            :footer-props="footerProps"
                            :server-items-length="pagination.itemsLength"
                            :mobile-breakpoint="0"
                            :page.sync="pagination.page"
                            name="docksData"
                            @pagination="updatePagination"
                        >
                            <template #item.name="{item}">
                                {{ item.name }}
                            </template>
                            <template #item.description="{item}">
                                {{ item.description }}
                            </template>
                            <template #item.isActive="{item}">
                                <v-icon
                                    v-if="item.isActive"
                                    small
                                    color="success"
                                >
                                    mdi-check
                                </v-icon>
                                <v-icon v-else small color="error">
                                    mdi-close
                                </v-icon>
                            </template>
                            <template #item.actions="{item}">
                                <div class="d-inline-flex">
                                    <v-tooltip :open-delay="tooltipDelay" top>
                                        <template #activator="{on}">
                                            <v-btn
                                                icon
                                                data-sentry-label="Edytuj"
                                                v-on="on"
                                                @click="showDockDialog(item.id)"
                                            >
                                                <v-icon color="teal">
                                                    mdi-pencil
                                                </v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Edycja</span>
                                    </v-tooltip>
                                </div>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import DockDialog from './DockDialog'
import pagination from '@/mixins/dataTablePagination'
import tooltipDelay from '@/mixins/tooltip'
import dateFormatter from '@/mixins/dateFormatter'
import customFilters from '@/mixins/customFilters'
import dataTableClassSetter from '@/mixins/dataTableClassSetter'
import { hasUserPermission } from '@/utils/permissionsHandler'
import { errorHandler } from '@/utils/errorHandler'

export default {
    name: 'Docks',
    components: {
        DockDialog,
    },
    mixins: [
        pagination,
        tooltipDelay,
        dateFormatter,
        customFilters,
        dataTableClassSetter
    ],
    data() {
        return {
            dockDialog: false,
            currentDock: {},
            headers: [
                {
                    text: 'Nazwa',
                    value: 'name',
                    sortable: false,
                    width: 200
                },
                {
                    text: 'Opis',
                    value: 'description',
                    sortable: false,
                },
                {
                    text: 'Akcje',
                    value: 'actions',
                    sortable: false,
                    align: 'center',
                    width: 100
                }
            ]
        }
    },
    computed: {
        docks() {
            return this.$store.state.shipping.notification.notification.docks
        },
        docksLoading() {
            return this.$store.state.shipping.notification.notification.docksLoading
        },
        dockTypes() {
            return this.$store.state.shipping.notification.notification.dockTypes
        },
        canCreateDock() {
            return hasUserPermission('notification_admin_create')
        },
    },
    mounted() {
        this.getDocks()
    },
    methods: {
        getDocks() {
            this.$store.dispatch('shipping/notification/getDocks', {
                paginate: this.paginate(),
                query: ''
            })
                .then(response => {
                    this.handlePaginationResponse(response)
                })
                .catch(error => {
                    errorHandler(error)
                })
        },
        createDock() {
            this.$store.dispatch('shipping/notification/getDockTypes')
                .then(() => {
                    this.currentDock = {}
                    this.dockDialog = true
                })
                .catch(error => {
                    errorHandler(error)
                })
        },
        showDockDialog(dockId) {
            Promise.all([
                this.$store.dispatch('shipping/notification/getDock', dockId),
                this.$store.dispatch('shipping/notification/getDockTypes')
            ])
                .then(responses => {
                    this.currentDock = responses[0].data
                    this.dockDialog = true
                })
                .catch(error => {
                    errorHandler(error)
                })
        },
        updatePagination(pagination) {
            this.pagination = pagination

            if (pagination.pageCount !== 0 && !this.paginationSettings.paginationPending) {
                this.getDocks()
            }
            this.clearPaginationPending()
        },
        confirmSaveDock() {
            this.getDocks()
        },
        closeDockDialog() {
            setTimeout(() => {
                this.currentDock = {}
            }, 500)
            this.dockDialog = false
        },
    }
}
</script>